export { renderDateRangeViewCalendar } from './dateRangeViewRenderers';